import {
  WR_USERS_WAITING_FAIL,
  WR_USERS_WAITING_REQUEST,
  WR_USERS_WAITING_RESET,
  WR_USERS_WAITING_SUCCESS,
} from "../constants/usersWaitingRoomConstans";

export const wsmodul_users_waiting_reducers = (
  state = { data: {} },
  action
) => {
  switch (action.type) {
    case WR_USERS_WAITING_REQUEST:
      return { loading: true };
    case WR_USERS_WAITING_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case WR_USERS_WAITING_FAIL:
      return { loading: false, error: action.payload };
    case WR_USERS_WAITING_RESET:
      return {};
    default:
      return state;
  }
};
